import { render } from "./HeaderNav.vue?vue&type=template&id=451bfbdb&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=451bfbdb&scoped=true&lang=scss"

import exportComponent from "/Users/cogliawho/Documents/WEBDEV/epicentric-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451bfbdb"]])

export default __exports__